import { render, staticRenderFns } from "./VTilesMenu.vue?vue&type=template&id=53eef5bd&"
import script from "./VTilesMenu.vue?vue&type=script&lang=js&"
export * from "./VTilesMenu.vue?vue&type=script&lang=js&"
import style0 from "./VTilesMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports